import { useAppDispatch, useAppSelector } from "store";

import { useEffect } from "react";

import { ModalWindow } from "components";
import { CertificatePage } from "components/pages/Certificate/CertificatePage";
import {
  certificateModalSelector,
  clearCertificate,
  getCertificate,
  toggleCertificateModal,
} from "features";

import "./CertificateModal.scss";

const CertificateModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, certificateGuid, pin } = useAppSelector(certificateModalSelector);

  useEffect(() => {
    if (isOpen && certificateGuid && pin) {
      dispatch(getCertificate({ Ссылка: certificateGuid, ПИН: pin }));
    }
  }, [isOpen, certificateGuid, pin, dispatch]);

  useEffect(() => {
    if (!isOpen) {
      dispatch(clearCertificate());
    }
  }, [isOpen, dispatch]);

  return (
    <ModalWindow
      isOpen={isOpen}
      toggleAction={toggleCertificateModal}
      classNames="modal-certificate"
    >
      <CertificatePage />
    </ModalWindow>
  );
};

export default CertificateModal;
